export default __webpack_public_path__ + "30d0623a2ce7a6232bc18d875294dd1a.png";